/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as ɵb} from './accordion-pane/accordion-pane.props';
export {registerProps as ɵa} from './accordion.props';